import React, { useEffect, useCallback, useState} from 'react';
import CycleAnalyzer from './CycleAnalyzer.js';
import {connect} from 'react-redux';

const ZJRepl = ({tidals}) => { 
    if (!tidals) {
        return (
            <div className="jrepl">
              Not connnected to jaki...
            </div>
        );
    }

    return (
        <div className="jrepl">
          {tidals.map(
              tidal =>
                  <CycleAnalyzer
                    key={tidal.id}
                    tidal={tidal}/>
          )}
        </div
        >);
}

const mapStateToProps = (state, props) => {
  return {
      tidals: props.jrepl.tidals
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ZJRepl);
